import { useQuery } from '@apollo/client';
import { GET_LISTING_AVERAGE_SELLING_TIME_FOR_POWER_SUPPLIES } from 'apollo-client';
import { HorizontalBarGraph } from 'components/HorizontalBarGraph';
import { Query, GetListingAverageSellingTimeForPowerSuppliesRequest } from 'generated/graphql';
import { useIntl } from 'react-intl';

export const SellingTimeForPowerSuppliesChart: (p: { vendorNames: Array<string> }) => JSX.Element | null = ({
  vendorNames,
}) => {
  const { formatMessage } = useIntl();
  const { loading, data } = useQuery<Query, GetListingAverageSellingTimeForPowerSuppliesRequest>(
    GET_LISTING_AVERAGE_SELLING_TIME_FOR_POWER_SUPPLIES,
    { variables: { vendorNames } }
  );
  return (
    <HorizontalBarGraph
      loading={loading}
      color="PRIMARY"
      barSeriesName={formatMessage({ id: 'averageSellingTimeForPowerSupplies' })}
      title={formatMessage({ id: 'averageSellingTimeForPowerSupplies' })}
      data={
        data?.getListingAverageSellingTimeForPowerSupplies?.map(({ powerSupply, sellingTimeInDays }) => ({
          x: formatMessage({ id: `powerSupply.${powerSupply}` }),
          y: sellingTimeInDays,
        })) || []
      }
    />
  );
};
